import dayjs from 'dayjs';
import ApiaApi, { makeApiaUrl } from '../../../../../api/apiaApi/apiaApi';

import store from '../../../../../store';
import { schedulerActions } from '../../../../../store/schedulerSlice';
import { TDateFormat } from '../../../../../types';
import { getDateFormat } from '../../../../../utils/date';
import { arrayOrArray, noNaN } from '../../../../../utils/util';
import { TScheduleResult, TTskSchDay } from '../types';
import { IButton } from './SchedulerMini';

const dateFormat: TDateFormat = getDateFormat();

export const setStage = (day: TTskSchDay, hour: number) => {
  makeMorningOrAfternoonStage(day);
  makeHoursStage(day, isMorningHandler(hour));
};
const isMorningHandler = (hour: number) => {
  if (Number(hour) < 1200) return true;
  return false;
};

const makeHoursStage = (day: TTskSchDay, isMorning: boolean) => {
  const thisDate = day.day;
  const hours = arrayOrArray(day.tskSchHour);
  const overassign = store.getState().schedulerSlice?.overassign;
  const parsingDay = dayjs(thisDate, dateFormat);
  const currentDate = dayjs();
  const currentHour = Number(dayjs().format('HHmm'));
  let morningOrAfternoonHours;
  if (isMorning) {
    morningOrAfternoonHours = hours?.filter((hour) => {
      return (
        ((parsingDay.isSame(currentDate, 'day') &&
          currentHour <= Number(hour.hour)) ||
          (!parsingDay.isSame(currentDate, 'day') &&
            Number(hour.value) + Number(overassign) > 0)) &&
        Number(hour.hour) < 1200
      );
    });
  } else {
    morningOrAfternoonHours = hours?.filter((hour) => {
      return (
        ((parsingDay.isSame(currentDate, 'day') &&
          currentHour <= Number(hour.hour)) ||
          (!parsingDay.isSame(currentDate, 'day') &&
            Number(hour.value) + Number(overassign) > 0)) &&
        Number(hour.hour) >= 1200
      );
    });
  }

  const enableHours = morningOrAfternoonHours?.filter((hour) => !hour.disabled);

  store.dispatch(
    schedulerActions.setStage({
      index: 2,
      stage: {
        name: 'daysHours',
        buttons: enableHours?.map((hour) => {
          const returnButton: IButton = {
            title: hour.hour,
            label: `${hour.hour.slice(0, -2)}:${hour.hour.slice(2)}`,
            value: hour.value,
            'aria-label': hour.hour,
            isSelectedSelector(global) {
              return global.schedulerSlice?.selectedDay?.hour === hour.hour;
            },
            action() {
              const isLoading = store.getState().schedulerSlice?.isLoading;
              if (isLoading !== 'NotLoading') return;
              const currentState = store.getState();
              store.dispatch(
                schedulerActions.setState({
                  selectedCell: `${hour.hour} ${String(
                    currentState.schedulerSlice?.selectedDay?.dayNumber,
                  )} ${
                    currentState.schedulerSlice?.selectedDay
                      ?.mondayWeek as string
                  }`,
                  labelSelectedDay: {
                    hour: hour.hour,
                    day: currentState.schedulerSlice?.selectedDay?.day,
                  },
                }),
              );
              store.dispatch(
                schedulerActions.setDay({
                  hour: hour.hour,
                  mondayWeek:
                    currentState.schedulerSlice?.selectedDay?.mondayWeek,
                }),
              );

              ApiaApi.get<TScheduleResult>(
                makeApiaUrl({
                  ajaxUrl: '/apia.design.TaskSchedulerAction.run',
                  action: 'setExecutionSchedulerSelectedDay',
                  weekDay: currentState.schedulerSlice?.selectedDay?.mondayWeek,
                  hour: hour.hour,
                  dayNumber:
                    currentState.schedulerSlice?.selectedDay?.dayNumber,
                }),
              )
                .then(() => {})
                .catch(() => {});
            },
          };

          return returnButton;
        }),
      },
    }),
  );
};

function makeMorningOrAfternoonStage(day: TTskSchDay) {
  const thisDate = day.day;
  const hours = arrayOrArray(day.tskSchHour);

  const overassign = store.getState().schedulerSlice?.overassign;
  const parsingDay = dayjs(thisDate, dateFormat);
  const currentDate = dayjs();
  const currentHour = Number(dayjs().format('HHmm'));

  const morningHours = hours?.filter((hour) => {
    return (
      ((parsingDay.isSame(currentDate, 'day') &&
        currentHour <= Number(hour.hour)) ||
        (!parsingDay.isSame(currentDate, 'day') &&
          Number(hour.value) + Number(overassign) > 0)) &&
      Number(hour.hour) < 1200
    );
  });
  const afternoonHours = hours?.filter((hour) => {
    return (
      ((parsingDay.isSame(currentDate, 'day') &&
        currentHour <= Number(hour.hour)) ||
        (!parsingDay.isSame(currentDate, 'day') &&
          Number(hour.value) + Number(overassign) > 0)) &&
      Number(hour.hour) >= 1200
    );
  });

  const morningButton: IButton = {
    isDisabled: (morningHours?.length ?? 0) === 0,
    label: window.LBL_SCHED_MORNING_TEXT,
    title: window.LBL_SCHED_MORNING_TEXT,
    'aria-label': window.LBL_SCHED_MORNING_TEXT,
    value: '',

    isSelectedSelector(global) {
      return isMorningHandler(
        global.schedulerSlice?.selectedDay
          ?.morningOrAfternoonSelected as number,
      );
    },
    action() {
      const isLoading = store.getState().schedulerSlice?.isLoading;
      if (isLoading !== 'NotLoading') return;

      store.dispatch(
        schedulerActions.setDay({
          morningOrAfternoonSelected: 1100,
        }),
      );

      const newStagesStringArray: string[] = [];

      makeHoursStage(day, isMorningHandler(1100));
      store.dispatch(
        schedulerActions.setState({
          stageList: newStagesStringArray,
        }),
      );
    },
  };

  const afternoonButton: IButton = {
    isDisabled: (afternoonHours?.length ?? 0) === 0,
    label: window.LBL_SCHED_AFTERNOON_TEXT,
    title: window.LBL_SCHED_AFTERNOON_TEXT,
    'aria-label': window.LBL_SCHED_AFTERNOON_TEXT,
    value: '',
    isSelectedSelector(global) {
      if (global.schedulerSlice?.selectedDay?.morningOrAfternoonSelected) {
        return !isMorningHandler(
          global.schedulerSlice?.selectedDay?.morningOrAfternoonSelected,
        );
      }
      return false;
    },
    action() {
      const isLoading = store.getState().schedulerSlice?.isLoading;
      if (isLoading !== 'NotLoading') return;

      store.dispatch(
        schedulerActions.setDay({
          morningOrAfternoonSelected: 1300,
        }),
      );

      makeHoursStage(day, isMorningHandler(1300));
    },
  };

  store.dispatch(
    schedulerActions.setStage({
      index: 1,
      stage: {
        name: 'morningOrAfternoon',
        buttons: [morningButton, afternoonButton].filter(
          (current): current is IButton => current !== null,
        ),
      },
    }),
  );
}

const makeDaysStage = (dayData?: TScheduleResult) => {
  const overassign = store.getState().schedulerSlice?.overassign;

  const availableDays =
    arrayOrArray(dayData?.tskSchDay).map((currentDay) => {
      const isDisabled = !arrayOrArray(currentDay?.tskSchHour).find((hour) => {
        const parsingDay = dayjs(currentDay.day, dateFormat);
        const currentDate = dayjs();
        const parsingHour = Number(hour.hour);
        const currentHour = Number(dayjs().format('HHmm'));

        if (
          (hour.hour !== undefined &&
            noNaN(hour.value) + noNaN(overassign) >= 0 &&
            !(
              parsingDay.isSame(currentDate, 'day') ||
              parsingDay.isBefore(currentDate, 'day')
            )) ||
          (parsingDay.isSame(currentDate, 'day') &&
            currentHour <= parsingHour &&
            !hour.disabled)
        ) {
          return true;
        }
        return false;
      });

      return { ...currentDay, isDisabled };
    }) ?? [];

  const availableDaysButtons = availableDays.map((day) => {
    const parsingDay = dayjs(day.day, dateFormat);

    const returnObject: IButton = {
      isDisabled: day.isDisabled,
      'aria-label': window.LBL_DAYS[dayjs(parsingDay).day()],
      title: day.day,
      label: `${window.LBL_DAYS[dayjs(parsingDay).day()]},  
        ${dayjs(parsingDay).get('date')}`,
      value: '',
      isSelectedSelector(global) {
        return global.schedulerSlice?.selectedDay?.day === day.day;
      },

      action: () => {
        const isLoading = store.getState().schedulerSlice?.isLoading;
        if (isLoading !== 'NotLoading') return;

        makeMorningOrAfternoonStage(day);

        const parsedMondayWeek = dayjs(dayData?.mondayWeek, dateFormat).get(
          'date',
        );
        const parsedDay = dayjs(day.day, dateFormat).get('date');

        store.dispatch(
          schedulerActions.setDay({
            mondayWeek: dayData?.mondayWeek,
            day: day.day,
            dayNumber: Number(parsedDay) - Number(parsedMondayWeek) + 1,
          }),
        );
      },
    };

    return returnObject;
  });

  store.dispatch(
    schedulerActions.setStage({
      index: 0,
      stage: {
        name: 'daysList',
        buttons: [...availableDaysButtons],
      },
    }),
  );
};

export default makeDaysStage;
